// import { metadata } from 'core-js/fn/reflect'

export default [
  {
    component: 'CNavItem',
    name: 'Übersicht',
    to: '/dashboard',
    faIcon: 'fas fa-gauge',
    meta: {
      requiredPermissions: [],
    },
  },
  {
    component: 'CNavItem',
    name: 'Betrieb',
    faIcon: 'fas fa-bolt',
    meta: {
      requiredPermissions: ['section_operations_view'],
    },
    items: [
      {
        component: 'CNavItem',
        name: 'Ladevorgänge',
        faIcon: 'fas fa-car-bolt',
        to: '/operations/transactions',
        meta: {
          requiredPermissions: ['feature_transactions_current_view'],
        },
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Konfiguration',
    faIcon: 'fas fa-square-sliders',
    meta: {
      requiredPermissions: ['section_configuration_view'],
    },
    items: [
      {
        component: 'CNavItem',
        name: 'Ladepunkte',
        faIcon: 'fas fa-charging-station',
        to: '/configuration/chargepoints',
        meta: {
          requiredPermissions: ['feature_chargepoints_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Token',
        faIcon: 'fas fa-key',
        to: '/configuration/idtoken',
        meta: {
          requiredPermissions: ['feature_idtokens_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Fahrzeuge',
        faIcon: 'fas fa-cars',
        to: '/configuration/vehicles',
        meta: {
          requiredPermissions: ['feature_vehicles_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Kalender',
        faIcon: 'fas fa-calendar',
        to: '/configuration/calendars',
        meta: {
          requiredPermissions: ['feature_calendars_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Displays',
        faIcon: 'fas fa-tv',
        to: '/configuration/displays',
        meta: {
          requiredPermissions: ['feature_displays_view'],
        },
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Verwaltung',
    faIcon: 'fas fa-screwdriver-wrench',
    meta: {
      requiredPermissions: ['section_admin_view'],
    },
    items: [
      {
        component: 'CNavItem',
        name: 'Benutzer',
        faIcon: 'fas fa-user-tie',
        to: '/administration/users',
        meta: {
          requiredPermissions: ['feature_users_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Rollen',
        faIcon: 'fas fa-users',
        to: '/administration/roles',
        meta: {
          requiredPermissions: ['feature_roles_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Berechtigungen',
        faIcon: 'fas fa-user-lock',
        to: '/administration/permissions',
        meta: {
          requiredPermissions: ['feature_permissions_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Liegenschaften',
        faIcon: 'fas fa-house',
        to: '/administration/properties',
        meta: {
          requiredPermissions: ['feature_properties_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Versionen',
        faIcon: 'fas fa-code-branch',
        to: '/administration/versions',
        meta: {
          requiredPermissions: ['section_admin_view'],
        },
      },
      {
        component: 'CNavItem',
        name: 'Schemavalidierung',
        faIcon: 'fas fa-database',
        to: '/administration/schema-validation',
        meta: {
          requiredPermissions: ['section_admin_view'],
        },
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Einstellungen',
    faIcon: 'fas fa-gears',
    meta: {
      requiredPermissions: ['section_settings_view'],
    },
    items: [
      {
        component: 'CNavItem',
        name: 'Zugangsdaten',
        faIcon: 'fas fa-fingerprint',
        to: '/settings/authentication',
        meta: {
          requiredPermissions: [], // Everyone can access their own settings
        },
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Logout',
    faIcon: 'fas fa-right-from-bracket',
    to: '/logout',
    meta: {
      requiredPermissions: [],
    },
  },
]
